/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/templates/page.full-width.js":
/*!**************************************************!*\
  !*** ./src/scripts/templates/page.full-width.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! slick-carousel/slick/slick.min.js */ \"./node_modules/slick-carousel/slick/slick.min.js\");\n/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _components_buttons_pause_html5_video__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/buttons/pause-html5-video */ \"./src/scripts/components/buttons/pause-html5-video.js\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! jquery */ \"jquery\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_3__);\n\r\n\r\n\r\n\r\n\r\n\r\ncharactersCarousel(); \r\n\r\njquery__WEBPACK_IMPORTED_MODULE_3___default()(document).ready(function(){\r\n\twaitForElementToDisplay(\"#input_19\", 200, setJotListeners)\r\n});\r\n\r\n// accessorioes carousel\r\nfunction charactersCarousel() {\r\n  var productCharactersCarousel = jquery__WEBPACK_IMPORTED_MODULE_3___default()('.js-characters__carousel');\r\n  productCharactersCarousel.slick({\r\n    infinite: false,\r\n    speed: 500,\r\n    slidesToShow: 4,\r\n    adaptiveHeight: true,\r\n    slidesToScroll: 1,\r\n    responsive: [\r\n      {\r\n        breakpoint: 767.99,\r\n        settings: {\r\n          slidesToShow: 3,\r\n          centerMode: false,\r\n          arrows: true\r\n        }\r\n      },\r\n      {\r\n        breakpoint: 580,\r\n        settings: {\r\n          slidesToShow: 2.25,\r\n          centerMode: false,\r\n          arrows: true\r\n        }\r\n      }\r\n    ]\r\n  });\r\n}\r\n\r\n/**\r\n * Set JOT form listeners\r\n */\r\nfunction setJotListeners(){\r\n\tvar jotForm = jquery__WEBPACK_IMPORTED_MODULE_3___default()('#200206375936151').contents();\r\n\tvar firstName = jotForm.find('#first_3');\r\n\tvar lastName = jotForm.find('#last_3');\r\n\tvar address1 = jotForm.find('#input_4_addr_line1');\r\n\tvar address2 = jotForm.find('#input_4_addr_line2');\r\n\tvar city = jotForm.find('#input_4_city');\r\n\tvar state = jotForm.find('#input_4_state');\r\n\tvar postal = jotForm.find('#input_4_postal');\r\n\tvar country = jotForm.find('#input_4_country');\r\n\t\r\n\tvar firstNameHidden = jotForm.find('#input_12');\r\n\tvar lastNameHidden = jotForm.find('#input_13');\r\n\tvar address1Hidden = jotForm.find('#input_14');\r\n\tvar address2Hiden = jotForm.find('#input_15');\r\n\tvar cityHiden = jotForm.find('#input_16');\r\n\tvar stateHidden = jotForm.find('#input_17');\r\n\tvar postalHidden = jotForm.find('#input_18');\r\n\tvar countryHidden = jotForm.find('#input_19');\r\n\tfirstName.change(function(){\r\n\t\tfirstNameHidden.val(firstName.val());\r\n\t});\r\n\tlastName.change(function(){\r\n\t\tlastNameHidden.val(lastName.val());\r\n\t});\r\n\taddress1.change(function(){\r\n\t\taddress1Hidden.val(address1.val());\r\n\t});\r\n\taddress2.change(function(){\r\n\t\taddress2Hiden.val(address2.val());\r\n\t});\r\n\tcity.change(function(){\r\n\t\tcityHiden.val(city.val());\r\n\t});\r\n\tstate.change(function(){\r\n\t\tstateHidden.val(state.val());\r\n\t});\r\n\tpostal.change(function(){\r\n\t\tpostalHidden.val(postal.val());\r\n\t});\r\n\tcountry.change(function(){\r\n\t\tcountryHidden.val(country.val());\r\n  });\r\n}\r\n\r\n/**\r\n * Wait for element to display\r\n * @param {string} selector \r\n * @param {number} time \r\n * @param {function} callback \r\n */\r\nfunction waitForElementToDisplay(selector, time, callback) {\r\n\tvar counter = 0;\r\n\tif(jquery__WEBPACK_IMPORTED_MODULE_3___default()('#200206375936151').contents().find(selector).length != 0) {\r\n\t\tcallback();\r\n\t\treturn;\r\n\t}\r\n\telse {\r\n\t\tcounter++;\r\n\t\tif(counter > 20){\r\n\t\t\tconsole.log('JotForm listener failed to catch input elements!')\r\n\t\t\treturn;\r\n\t\t}\r\n\t\tsetTimeout(function() {\r\n\t\t\twaitForElementToDisplay(selector, time, callback);\r\n\t\t}, time);\r\n\t}\r\n}\r\n\n\n//# sourceURL=webpack://starter-theme/./src/scripts/templates/page.full-width.js?");

/***/ }),

/***/ "jquery":
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/***/ ((module) => {

module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"template.page.full-width": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkstarter_theme"] = globalThis["webpackChunkstarter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./src/scripts/templates/page.full-width.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;